import styled from '@emotion/styled';
import { Field, Icon, getInputContainerStyles, getInputStyles, tokens } from '@hotjar/hotsauce';

import * as CommonStyles from '../styles';

export const S = {
  Container: styled(CommonStyles.SectionContainer)`
    padding: ${tokens.spacer.x3} ${tokens.spacer.x2} ${tokens.spacer.x5} ${tokens.spacer.x2};
  `,
  CardIcons: styled.div`
    display: flex;
    gap: ${tokens.spacer.x2};
  `,
  Field: styled(Field)<{ width: string }>`
    width: ${(props) => props.width};
    min-width: 0;
    position: relative;
    label {
      text-transform: unset;
      white-space: nowrap;
    }
  `,
  Form: styled.form`
    margin-top: ${tokens.spacer.x3};
    ${tokens.flexContainer('form')};
  `,
  Row: styled.div`
    ${tokens.flexContainer('default')}
  `,
  TooltipContainer: styled.div`
    position: absolute;
    right: 3px;
    top: 3px;
    line-height: 1;
  `,
  InputContainer: styled.div<Parameters<typeof getInputContainerStyles>[0]>`
    ${({ isInvalid, isReadonly, isDisabled }) =>
      getInputContainerStyles({
        isInvalid,
        isReadonly,
        isDisabled,
        isActionPresent: false,
      })};
    cursor: text;
  `,
  Input: styled.div<Parameters<typeof getInputStyles>[0]>`
    ${({ isInvalid, readOnly }) =>
      getInputStyles({
        isInvalid,
        readOnly,
        inputSize: 'm',
        isIconPresent: false,
      })};
    // We're leaving 1px space top & bottom so that autofill background doesn't cover borders
    iframe {
      height: calc(100% - 2px) !important;
      margin-top: 1px;
    }
  `,
  DateInnerContainer: styled.div`
    display: flex;
    height: 100%;
    position: relative;
    // Custom / symbol between month and year fields
    & > *:first-of-type {
      width: ${tokens.spacer.x4};
      flex-shrink: 0;
    }
    &::after {
      content: '/';
      display: block;
      position: absolute;
      left: 25px;
      top: ${tokens.spacer.x1};
      color: ${tokens.color.text_disabled};
      ${tokens.text('body1')};
    }
  `,
  HostedFieldInnerContainer: styled.div`
    height: 100%;
  `,
  InputIcon: styled(Icon)<{ minimizeIconSpace: boolean }>`
    margin: auto;
    flex: 0 0 auto;
    margin-right: ${tokens.spacer.x2};
    ${({ minimizeIconSpace }) =>
      minimizeIconSpace &&
      `position: absolute;
      right: -4px;`}
  `,
};
